import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/funnelChart";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

export function ProspectTypesFilter({ showProspectTypesFilter }) {
  const dispatch = useDispatch();

  const startFrom = useSelector((state) => state.laser.selectedFilters.startFrom.id);

  const options = useSelector((state) => state.laser.prospectTypes);
  const selected = useSelector((state) => state.laser.selectedFilters.prospectTypes);
  const prospectTypesLoading = useSelector((state) => state.laser.prospectTypesLoading);

  const showFilter =
    showProspectTypesFilter &&
    (startFrom === "leads" || startFrom === "appointments" || startFrom === "shows");

  return showFilter ? (
    <div className="select-box" style={{ width: "150px" }}>
      <p className="offers-title">Prospect Types</p>
      {prospectTypesLoading ? (
        <button className="picky__input">
          <LoadingAnimation uiLoader />
        </button>
      ) : (
        <MultiSelectDropdown
          options={options}
          selectedFilters={selected}
          numberDisplayed={0}
          includeSelectAll
          enableOnly
          onSelectChange={(data) => dispatch(actionCreators.setProspectTypes(data))}
        />
      )}
    </div>
  ) : null;
}
